module.exports = __webpack_public_path__ + "img/icon_left_arrow.7b2d8892.svg";